// extracted by mini-css-extract-plugin
module.exports = {"tablesContainer":"Tables_tablesContainer__MWMFI","title":"Tables_title__39N9f","content":"Tables_content__3Rj3W","item":"Tables_item__1hVGH"};